export const PRICE = '600 грн'
